module.exports = __webpack_public_path__ + "static/palco-desk-829fc7b400a10e08b089bf49087d7542.png";